/**
 * Typed access to Vite environment variables (embedded at build time).
 */
function readBool(value: string | undefined, defaultValue: boolean): boolean {
  if (value === undefined || value === "") {
    return defaultValue;
  }
  return value !== "false";
}

export const env = {
  apiUrl: import.meta.env.VITE_API_URL ?? "http://127.0.0.1:10103",
  platform: import.meta.env.VITE_PLATFORM ?? "glofox",
  themeApiPath: import.meta.env.VITE_THEME_API_PATH ?? "/api-portal/v1/theme",
  themeUseMock: readBool(import.meta.env.VITE_THEME_USE_MOCK, true),
  /** Markdoc docs site base (same-origin). Production: `/api-portal-docs/`. */
  docsBaseUrl: import.meta.env.VITE_DOCS_BASE_URL ?? "/api-portal-docs/",
  userRegisterPath:
    import.meta.env.VITE_USER_REGISTER_PATH ?? "/api/v1/users/register",
  authLoginPath:
    import.meta.env.VITE_AUTH_LOGIN_PATH ?? "/api/v1/auth/login",
  authForgotPasswordPath:
    import.meta.env.VITE_AUTH_FORGOT_PASSWORD_PATH ??
    "/api/v1/auth/forgot-password",
  authResetPasswordPath:
    import.meta.env.VITE_AUTH_RESET_PASSWORD_PATH ??
    "/api/v1/auth/reset-password",
  authVerifyEmailPath:
    import.meta.env.VITE_AUTH_VERIFY_EMAIL_PATH ?? "/api/v1/auth/verify-email",
  authResendVerificationPath:
    import.meta.env.VITE_AUTH_RESEND_VERIFICATION_PATH ??
    "/api/v1/auth/resend-verification",
  adminAuthLoginPath:
    import.meta.env.VITE_ADMIN_AUTH_LOGIN_PATH ?? "/api/v1/admin/auth/login",
  adminAuthMePath:
    import.meta.env.VITE_ADMIN_AUTH_ME_PATH ?? "/api/v1/admin/auth/me",
  adminAuthForgotPasswordPath:
    import.meta.env.VITE_ADMIN_AUTH_FORGOT_PASSWORD_PATH ??
    "/api/v1/admin/auth/forgot-password",
  adminAuthResetPasswordPath:
    import.meta.env.VITE_ADMIN_AUTH_RESET_PASSWORD_PATH ??
    "/api/v1/admin/auth/reset-password",
  launchDarklyClientSideId:
    import.meta.env.VITE_LAUNCHDARKLY_CLIENT_SIDE_ID ?? "",
  launchDarklyEnabled: readBool(
    import.meta.env.VITE_LAUNCHDARKLY_ENABLED,
    false,
  ),
  /**
   * Local preview of the Developer Platform landing while LaunchDarkly is off.
   * LaunchDarkly owns the value whenever the SDK is enabled.
   */
  multiPlatformDocsEnabled: readBool(
    import.meta.env.VITE_MULTI_PLATFORM_DOCS_ENABLED,
    false,
  ),
  /** Glofox Studio login for sandbox test locations (public URL). */
  glofoxStudioDashboardUrl:
    import.meta.env.VITE_GLOFOX_STUDIO_DASHBOARD_URL ??
    "https://bartik.glofox.com/dashboard/#/login",
} as const;

export type AppEnv = typeof env;
